/**
 * Personstamm API
 * API for Personstamm Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PersonStammMasterId } from './personStammMasterId';
import { FieldMetaData } from './fieldMetaData';
import { PersonStammVersionDetailEntryMeta } from './personStammVersionDetailEntryMeta';
import { PersonAdresseListEntryMeta } from './personAdresseListEntryMeta';


export interface PersonStammMasterDetailEntryMeta { 
    masterId?: PersonStammMasterId;
    mMasterId?: FieldMetaData;
    kantPersonId?: string;
    mKantPersonId?: FieldMetaData;
    printRTFpossible?: boolean;
    mPrintRTFpossible?: FieldMetaData;
    capiPersonId?: number;
    mCapiPersonId?: FieldMetaData;
    adressen?: Array<PersonAdresseListEntryMeta>;
    mAdressen?: FieldMetaData;
    printPDFpossible?: boolean;
    mPrintPDFpossible?: FieldMetaData;
    egbpid?: string;
    mEgbpid?: FieldMetaData;
    datenquelle?: string;
    mDatenquelle?: FieldMetaData;
    auskunftsperre?: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum;
    mAuskunftsperre?: FieldMetaData;
    version?: PersonStammVersionDetailEntryMeta;
    mVersion?: FieldMetaData;
}
export namespace PersonStammMasterDetailEntryMeta {
    export type AuskunftsperreEnum = 'AUSKUNFT_SPERRE' | 'ADRESS_SPERRE' | 'KEINE';
    export const AuskunftsperreEnum = {
        AUSKUNFTSPERRE: 'AUSKUNFT_SPERRE' as AuskunftsperreEnum,
        ADRESSSPERRE: 'ADRESS_SPERRE' as AuskunftsperreEnum,
        KEINE: 'KEINE' as AuskunftsperreEnum
    };
}


